"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockApi3ReaderProxy__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        name: "mock",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "read",
        outputs: [
            {
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x6080604052348015600f57600080fd5b506102168061001f6000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c806357de26a41461003b5780635b25966614610066575b600080fd5b61004361007b565b60408051601b9390930b835263ffffffff90911660208301520160405180910390f35b610079610074366004610198565b6100ec565b005b60008054601b81900b91600160e01b90910463ffffffff16908190036100e85760405162461bcd60e51b815260206004820152601460248201527f446174612066656564206e6f74206d6f636b656400000000000000000000000060448201526064015b60405180910390fd5b9091565b8063ffffffff166000036101425760405162461bcd60e51b815260206004820152600e60248201527f54696d657374616d70207a65726f00000000000000000000000000000000000060448201526064016100df565b7bffffffffffffffffffffffffffffffffffffffffffffffffffffffff90911663ffffffff909116600160e01b027fffffffff000000000000000000000000000000000000000000000000000000001617600055565b600080604083850312156101ab57600080fd5b823580601b0b81146101bc57600080fd5b9150602083013563ffffffff811681146101d557600080fd5b80915050925092905056fea264697066735822122057f183fa46149e16f40f251d6280d5ff130fefeb77fc6efb5c35613be75e73be64736f6c634300081b0033";
const isSuperArgs = (xs) => xs.length > 1;
class MockApi3ReaderProxy__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.MockApi3ReaderProxy__factory = MockApi3ReaderProxy__factory;
//# sourceMappingURL=MockApi3ReaderProxy__factory.js.map